// extracted by mini-css-extract-plugin
export default {"root":"SaasLogin_root__joWxR"};